export const LARGE_CUSTOM_TRAY_PRODUCT_KEY = '9901';
export const MEDIUM_CUSTOM_TRAY_PRODUCT_KEY = '9900';

export const LARGE_CUSTOM_TRAY_SKU = `${LARGE_CUSTOM_TRAY_PRODUCT_KEY}-05`;
export const MEDIUM_CUSTOM_TRAY_SKU = `${MEDIUM_CUSTOM_TRAY_PRODUCT_KEY}-03`;
